/**
 * Sets a parameter in URL.
 * @param param - Identifier of the parameter.
 * @param value - Value of the parameter.
 * @param href - URL to be modified.
 * @returns Modified URL.
 */
export function setURLParam(param, value, href = window.location.href) {
    const url = new URL(href);
    url.searchParams.set(param, value);
    window.history.replaceState(null, '', url.href);
    return url.href;
}
/**
 * Gets a parameter from URL.
 * @param param - Identifier of the parameter.
 * @param href - URL to be queried.
 * @returns - Value of the parameter.
 */
export function getURLParam(param, href = window.location.href) {
    const url = new URL(href);
    return url.searchParams.get(param);
}
/**
 * Constructs a URL relative to the current URL.
 * @param href - URL to be constructed.
 * @returns Relative URL.
 */
export function getRelativeURL(href) {
    const currentLocation = window.location;
    const currentHref = currentLocation.href.endsWith('/') ? currentLocation.href : `${currentLocation.href}/`;
    const url = new URL(href, currentHref);
    return url.pathname;
}
/**
 * Deletes a parameter from the URL.
 * @param param - Identifier of the parameter.
 * @param href - URL to be modified.
 * @returns Modified URL.
 */
export function deleteURLParam(param, href = window.location.href) {
    const url = new URL(href);
    url.searchParams.delete(param);
    window.history.replaceState(null, '', url.href);
    return url.href;
}
